import { ReferralType } from '../constants';
import { BiEvent } from './base';

/** These fields are allowed to be pulled from context */
export interface BiContextAllowedProps {
  /** prop for internal use to calculate rank - only for use in context provider,
   *  in events use rank instead */
  _rankOffset?: number;
  /** prop for internal use to calculate rank - only for use in context provider,
   *  in events use rank instead */
  _rankIndex?: number;

  authorid?: string;
  chat_list_type?: string;
  chat_uuid?: string;
  component?: string;
  creatorid?: string;
  feed_mode?: 'feed' | 'saved' | 'removed';
  groupid?: string | number;
  is_comment_thread?: 0 | 1;
  is_expanded?: 0 | 1;
  is_grouped?: 0 | 1;
  itemid?: number;
  items_selected_count?: number;
  notification_message_id?: string;
  notification_sender_id?: string;
  notification_type?: string;
  page_itemid?: number;
  page_typeid?: number;
  pollid?: number;
  rank?: number;
  reason_shown?: string;
  referral_info?: ReferralType;
  section_typeid?: number;
  sectionid?: number;
  sectionname?: string;
  sectionrank?: number;
  sectiontype?: string;
  sort_type?: string;
  source_type?: string;
  typeid?: number;
  template_id?: string;
  view?: string;
  widgetname?: string;
  widgetzone?: string;
}

/** Symbol to signal "pull this field from context" */
export const BiContextProvidedValue = Symbol('BiContextProvidedValue');

type AddContextValue<
  TEvent,
  TKey extends keyof TEvent
> = TKey extends keyof BiContextAllowedProps // if it's a valid key in the context
  ? TEvent[TKey] extends BiContextAllowedProps[TKey] // and if it's the same type, too
    ? TEvent[TKey] | typeof BiContextProvidedValue // then allow the symbol as value, too
    : TEvent[TKey] // otherwise we fall back to the original type
  : TEvent[TKey];

export type Contextify<T extends BiEvent> = {
  [key in keyof T]: key extends keyof BiEvent
    ? T[key] // evid and the internal use fields should not come from context
    : AddContextValue<T, key>;
};

/** BiData that supports pulling from context, use for logging from components */
export function BiData<T extends BiEvent>(data: Contextify<T>): Contextify<T> {
  return { ...data, _biLoggerVersion: 2 };
}
